export enum ShipmentStatus {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Sent = 'SENT',
}
